interface FilledChatIconProps {
  size?: number;
  color?: string;
}

export function FilledChatIcon({
  size = 14,
  color = "currentColor",
}: FilledChatIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16 3C8.28 3 2 8.04 2 14.2c0 3.56 1.94 6.74 5 8.88-.12 1.52-.68 3.24-1.92 4.92 3.04-.12 5.84-1.36 7.56-2.72 1.08.2 2.2.32 3.36.32 7.72 0 14-5.04 14-11.2S23.72 3 16 3Z" />
    </svg>
  );
}
